import SelectBox from "devextreme-react/select-box";
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";
import { LoadPanel } from "devextreme-react/load-panel";
import React from "react";
import {
  Validator, RequiredRule, EmailRule, PatternRule,
  StringLengthRule,
  RangeRule,
  AsyncRule,
} from "devextreme-react/validator";
import { useEffect, useState } from "react";
import { config } from "../config";
import { useHistory } from "react-router-dom";
import FileUploader from "devextreme-react/file-uploader";
import { CheckBox } from 'devextreme-react/check-box';
import api from "../request/api";
import DataSource from "devextreme/data/data_source";
import { Popup } from "devextreme-react/popup";
import baner from "../Assets/baner.png";
import { Portal } from "../_components/Portal";
import { confirm, alert } from "devextreme/ui/dialog";
import ReCAPTCHA from 'react-google-recaptcha';
import { HtmlContentEditor } from "../_components/HtmlContentEditor";
import notify from "devextreme/ui/notify";



const AddReclamation = () => {
  const history = useHistory();
  const fileInputRef = React.createRef();

  const [street, setStreet] = useState();
  const [selectedStreet, setSelectedStreet] = useState();
  const [email, setEmail] = useState();
  const [house, setHouse] = useState();
  const [apartment, setApartment] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [contentText, setContentText] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState();
  const [popupData, setPopupData] = useState();
  const [popupVisible, setPopupVisible] = useState(false);
  const [tokenIsValid, setTokenIsValid] = useState(false);
  const [accepterdConditions, setAccepterdConditions] = useState(false);

  const handleOnClear = () => {
    const result = confirm(
      "Czy na pewno chcesz wyczyścić cały formularz?",
      "Uwaga"
    );
    result.then((dialogResult) => {
      if (dialogResult) {
        setSelectedStreet(undefined);
        setEmail(null);
        setHouse(null);
        setApartment(null);
        setFirstName(null);
        setLastName(null);
        setContentText(null);
        setFiles(undefined);
      }
    });
  };

  useEffect(async () => {
    const { data } = await api.get(config.apiUrl + "ZipCode/GetStreets");
    setStreet(data);


  }, []);

  const submitData = async () => {
    setTokenIsValid(false);

    let param = {
      feedbackType: "Reklamacja",
      email: email,
      street: selectedStreet,
      house: house,
      content: contentText,
      apartment: apartment,
      firstName: firstName,
      lastName: lastName,
    };

    console.log(param, "param")
    const form = getFormData(param);
    if (files)
      files.forEach((file) => {
        form.append("attachments", file);
      });

    const { data } = await api.post(config.apiUrl + "Feedback/Add", form);
    setPopupData(data);
    if (data) {
      setPopupVisible(true);
    }
    setIsLoading(false);
    clearValue();
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    submitData();
  };
  const getFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      if (
        object[key] != null &&
        (!Array.isArray(object[key]) ||
          (Array.isArray(object[key]) && object[key].length > 0))
      ) {
        Array.isArray(object[key])
          ? object[key].forEach((value) => formData.append(key + "[]", value))
          : formData.append(key, object[key]);
      }
      return formData;
    }, new FormData());

  const selectBoxData = new DataSource({
    store: street,
    paginate: true,
    pageSize: 10,
  });

  const clearValue = () => {
    setEmail(null);
    setHouse(null);
    setFirstName(null);
    setLastName(null);
    setApartment(null);
    setContentText(null);
    setFiles(null);
    setSelectedStreet(null);
  };

  const onChange = async (e) => {
    const { data } = await api.post(config.apiUrl + "Feedback/CheckRecaptcha", { token: e });
    if (data) {
      setTokenIsValid(data.success)
    } else {
      setTokenIsValid(false);
    }
  }

  const fileHandleChange = (e) => {

    const extensions = ["image/jpeg", "image/gif", "image/png", "image/tiff"]

    for (let i = 0; i < e.length; i++) {
      if (!extensions.includes(e[i].type)) {
        notify("Nieprawidłowy format pliku. Obsługiwane tylko formaty graficzne np. jpg, png", "error", 5000);
        return;
      }
    }

    let sizeArray = e.map(x => x.size);

    if (sizeArray.reduce((partialSum, a) => partialSum + a, 0) > 10000000) {
      notify("Zbyt duże pliki. Maksymalny łączny rozmiar to 10MB", "error", 5000);
      return;
    }
    setFiles(e);


  }
  return (
    <>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={isLoading}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />
      <Popup
        visible={popupVisible}
        onHiding={() => {
          setPopupData(null);
          setPopupVisible(false);
          window.location.reload();
        }}
        dragEnabled={false}
        closeOnOutsideClick={false}
        showCloseButton={true}
        showTitle={true}
        title="e-Reklamacje"
        container=".dx-viewport"
        width="80%"
      >
        <div className="">
          <h2>Dodano reklamację</h2>
          <div className="col-12 ">
            <p>
              Twoja reklamacja została przekazana do Urzędu Miejskiego we
              Wrocławiu.
            </p>
            <p>
              Na podany adres e-mail zostało wysłane potwierdzenie złożenia
              reklamacji z nadanym numerem sprawy.
            </p>
            <span>Numer sprawy: {popupData && popupData.number}</span>
            <p>
              Status reklamacji możesz sprawdzić tutaj:{" "}
              <a href="https://status-odpady.um.wroc.pl">e-Status</a> wpisując numer sprawy.
            </p>
          </div>
        </div>
      </Popup>
      <div className="card">
        <div className="col-12">
          <div
            className="mainHeader"
            style={{ backgroundImage: `url(${baner})` }}
          >

          </div>
        </div>

        <form action="your-action" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12 col-xl-8 left">
              <div className="formSection">
                <div className="col-12 secendaryHeader">
                  <span className="secendaryHeaderText">
                    Dane reklamującego
                  </span>
                </div>
                <div className="section">
                  <div className="box">
                    <label htmlFor="email">e-mail:</label>
                    <TextBox
                      id="email"
                      inputAttr={{ id: 'email' }}
                      aria-required="true"
                      aria-describedby="email"
                      maxLength={250}
                      placeholder=""
                      name="email"
                      onValueChange={(e) => {
                        setEmail(e.toUpperCase());
                      }}
                      value={email}
                      stylingMode="underlined"
                    >
                      <Validator>
                        <RequiredRule message="Email jest wymagany" />
                        <EmailRule message="Email jest nieprawidłowy, np. kowalski@gmail.com" />
                      </Validator>
                    </TextBox>
                  </div>
                  <p>
                    <small className="validationText">*pole wymagane</small>
                  </p>
                  <div className="box">
                    <label htmlFor="firstName">imię:</label>
                    <TextBox
                      id="firstName"
                      inputAttr={{ id: 'firstName' }}
                      aria-required="true"
                      aria-describedby="firstName"
                      maxLength={50}
                      onValueChange={(e) => {
                        setFirstName(e.toUpperCase());
                      }}
                      value={firstName}
                      stylingMode="underlined"
                    >
                      <Validator>
                        <RequiredRule message="Imię jest wymagane" />
                        <PatternRule message="Imię nie może zawierać cyfr" pattern={'^[^0-9]+$'} />
                      </Validator>
                    </TextBox>
                  </div>
                  <p>
                    <small className="validationText">*pole wymagane</small>
                  </p>
                  <div className="box">
                    <label htmlFor="lastName">nazwisko:</label>
                    <TextBox

                      id="lastName"
                      inputAttr={{ id: 'lastName' }}
                      aria-required="true"
                      aria-describedby="lastName"
                      maxLength={50}
                      onValueChange={(e) => {
                        setLastName(e.toUpperCase());
                      }}
                      value={lastName}
                      stylingMode="underlined"
                    >
                      <Validator>
                        <RequiredRule message="Nazwisko jest wymagane" />
                        <PatternRule message="Nazwisko nie może zawierać cyfr" pattern={'^[^0-9]+$'} />
                      </Validator>
                    </TextBox>
                  </div>
                  <p>
                    <small className="validationText">*pole wymagane</small>
                  </p>
                </div>
              </div>
              <hr />
              <div className="formSection two">
                <div className="col-12 secendaryHeader">
                  <span className="secendaryHeaderText">
                    Dane dotyczące miejsca reklamacji
                  </span>
                </div>
                <div className="section">
                  <div className="box">
                    <label htmlFor="street">ulica:</label>
                    <SelectBox
                      id="street"
                      inputAttr={{ id: 'street' }}
                      aria-required="true"
                      aria-describedby="street"
                      placeholder="Ulica"
                      searchEnabled={true}
                      dataSource={selectBoxData}
                      onValueChange={(e) => setSelectedStreet(e)}
                      value={selectedStreet}
                      stylingMode="underlined"
                    >
                      <Validator>
                        <RequiredRule message="Ulica jest wymagana" />
                      </Validator>
                    </SelectBox>
                  </div>
                  <p>
                    <small className="validationText">*pole wymagane</small>
                  </p>
                  <div className="box">
                    <label htmlFor="house">nr domu:</label>
                    <TextBox
                      id="house"
                      inputAttr={{ id: 'house' }}
                      aria-required="true"
                      aria-describedby="house"
                      maxLength={30}
                      name="house"
                      onValueChange={(e) => {
                        setHouse(e.toUpperCase());
                      }}
                      value={house}
                      stylingMode="underlined"
                    >
                      <Validator>
                        <RequiredRule message="Numer domu jest wymagany" />
                      </Validator>
                    </TextBox>
                  </div>
                  <p>
                    <small className="validationText">*pole wymagane</small>
                  </p>
                  <div className="box">
                    <label htmlFor="apartment">nr lokalu:</label>
                    <TextBox
                      id="apartment"
                      inputAttr={{ id: 'apartment' }}
                      aria-required="true"
                      aria-describedby="apartment"
                      maxLength={15}
                      onValueChange={(e) => {
                        setApartment(e.toUpperCase());
                      }}
                      value={apartment}
                      stylingMode="underlined"
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div className="formSection mce 3">
                <div className="col-12 secendaryHeader mb-3">
                  <span className="secendaryHeaderText">Treść zgłoszenia</span>
                </div>

                <div className="section">
                  <HtmlContentEditor
                    setValue={setContentText}
                    value={contentText}
                    disabled={false}
                  />
                </div>

              </div>
              <div className="formSection mce 3">
                <div className="col-12 secendaryHeader mb-3">
                  <span className="secendaryHeaderText">Zgoda</span>
                </div>
                <div className="conditions">
                  <div>
                    <CheckBox
                      style={{ border: '2px solid', borderRadius: '4px' }}
                      value={accepterdConditions}
                      onValueChange={(e) => setAccepterdConditions(e)}
                    />
                  </div>
                  <div>
                    Wyrażam zgodę, aby moje dane osobowe w zakresie obejmującym: imię i nazwisko, adres email, dane adresowe nieruchomości były przetwarzane przez Prezydenta Wrocławia w celu obsłużenia reklamacji. Zgoda może być w każdym momencie wycofana poprzez kontakt z Administratorem danych: listownie na adres Prezydent Wrocławia, Urząd Miejski Wrocławia, pl. Nowy Targ 1-8, 50-141 Wrocław, przez e-mail: wpo@um.wroc.pl, telefonicznie: 71 777 81 39 lub Inspektorem Ochrony Danych  listownie na adres: ul. G. Zapolskiej 4, 50-032 Wrocław przez e-mail: iod@um.wroc.pl, telefonicznie: 71 777 77 24.
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-xl-4 attachments">
              <div className="formSection">
                <div className="col-12 secendaryHeader">
                  <span className="secendaryHeaderText">Załączniki</span>
                </div>
                <div className="fileuploader-container">
                  <FileUploader
                    className="attachmentFeedback"
                    ref={fileInputRef}
                    selectButtonText="Wybierz załącznik"
                    labelText=""
                    accept={['.jpg', '.jpeg', '.gif', '.png', '.tif']}
                    uploadMode="useButtons"
                    onValueChanged={(e) => fileHandleChange(e.value)}
                    value={files != null ? files : []}
                    multiple
                  />
                </div>
              </div>
            </div>

            <div className="col-12 col-xl-8 ">
              <ReCAPTCHA
                sitekey="6LcOuJggAAAAAJs83fkPfcu7AWeE0V31b9_43fpp"
                onChange={onChange}
              />

            </div>

            <div className="col-12 col-xl-8">
              <div className="d-flex justify-content-between buttonPrimarySection">
                <Button
                  text="Wyczyść formularz"
                  onClick={() => handleOnClear()}
                  className="button"
                />
                {tokenIsValid && accepterdConditions &&
                  <Button
                    id="submitButton"
                    text="Wyślij e-Reklamację"
                    className="buttonSuccess"
                    useSubmitBehavior={true}
                  />
                }
              </div>
            </div>
            <div className="col-12 col-xl-4 attachments"></div>
          </div>
        </form>
      </div>
    </>
  );
};

export { AddReclamation };
